var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerLightGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 21.5H23.9999V18H-6.10352e-05V21.5ZM-6.10352e-05 12.75H23.9999V9.25H-6.10352e-05V12.75ZM-6.10352e-05 0.5V4H23.9999V0.5H-6.10352e-05Z",
    fill: "#E9ECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerLightGray);
export default __webpack_public_path__ + "static/media/hamburger-light-gray.2e52c78a7774ba2e14735a60a019b150.svg";
export { ForwardRef as ReactComponent };